<vp-global-spinner data-testid="global-spinner"></vp-global-spinner>
<vp-toolbar *ngIf="authenticated | async" class="app-header" [isAuthenticated]="authenticated" (logoutClick)="logout()"></vp-toolbar>
<div class="app-content" [class.vp-auth]="authenticated | async">
    <router-outlet></router-outlet>
</div>
<vp-footer class="app-footer"></vp-footer>
